import { render, staticRenderFns } from "./DocCarousel.vue?vue&type=template&id=57dc8783&"
import script from "./DocCarousel.vue?vue&type=script&lang=js&"
export * from "./DocCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports